

export function Experience() {
  return (

    <ul className="experience-list">
      <li>სამედიცინო ჰოლდინგი 23</li>
      <li>საქართველოს სადაზღვევო ჯგუფი</li>
      <li>დევნილთა, შრომის, ჯანმრთელობისა და სოციალური დაცვის სამინისტრო</li>
      <li>ჯიპიაი ჰოლდინგი • GPI Holding</li>
      <li>ჯანდაცვის მოწინავე სისტემების ბიურო</li>
      <li>მეთექვსმეტე პოლიკლინიკა</li>
      <li>პედიატრიული პრივატ კლინიკა</li>
    </ul>
    
    
  );
}